export type WithKey<T> = T & { key: string };

export default <T>(record: Record<string, T>): WithKey<T>[] => {
    return Object.entries(record).map(([key, value]) => ({ ...value, key }));
};
